/* ------------------------------------------------------------------------------
 *
 *  # UI Components Module
 *
 *  Tooltips, Popovers, and other UI components
 *
 * ---------------------------------------------------------------------------- */

// Tooltip
export function componentTooltip() {
    const tooltipSelector = document.querySelectorAll('[data-bs-popup="tooltip"]');

    tooltipSelector.forEach(function (popup) {
        new bootstrap.Tooltip(popup, {
            boundary: '.page-content'
        });
    });
}

// Popover
export function componentPopover() {
    const popoverSelector = document.querySelectorAll('[data-bs-popup="popover"]');

    popoverSelector.forEach(function (popup) {
        new bootstrap.Popover(popup, {
            boundary: '.page-content'
        });
    });
}

// "Go to top" button
export function componentToTopButton() {
    // Elements
    const toTopContainer = document.querySelector('.content-wrapper'),
        toTopElement = document.createElement('button'),
        toTopElementIcon = document.createElement('i'),
        toTopButtonContainer = document.createElement('div'),
        toTopButtonColorClass = 'btn-secondary',
        toTopButtonIconClass = 'ph-arrow-up',
        scrollableContainer = document.querySelector('.content-inner'),
        scrollableDistance = 250,
        footerContainer = document.querySelector('.navbar-footer');

    // Append only if container exists
    if (scrollableContainer) {
        // Create button container
        toTopContainer.appendChild(toTopButtonContainer);
        toTopButtonContainer.classList.add('btn-to-top');

        // Create button
        toTopElement.classList.add('btn', toTopButtonColorClass, 'btn-icon', 'rounded-pill');
        toTopElement.setAttribute('type', 'button');
        toTopButtonContainer.appendChild(toTopElement);
        toTopElementIcon.classList.add(toTopButtonIconClass);
        toTopElement.appendChild(toTopElementIcon);

        // Show and hide on scroll
        const to_top_button = document.querySelector('.btn-to-top'),
            add_class_on_scroll = () => to_top_button.classList.add('btn-to-top-visible'),
            remove_class_on_scroll = () => to_top_button.classList.remove('btn-to-top-visible');

        scrollableContainer.addEventListener('scroll', function () {
            const scrollpos = scrollableContainer.scrollTop;
            scrollpos >= scrollableDistance ? add_class_on_scroll() : remove_class_on_scroll();
            if (footerContainer) {
                if (this.scrollHeight - this.scrollTop - this.clientHeight <= footerContainer.clientHeight) {
                    to_top_button.style.bottom = footerContainer.clientHeight + 20 + 'px';
                }
                else {
                    to_top_button.removeAttribute('style');
                }
            }
        });

        // Scroll to top on click
        document.querySelector('.btn-to-top .btn').addEventListener('click', function () {
            scrollableContainer.scrollTo(0, 0);
        });
    }
}

// Dropdown submenus. Trigger on click
export function dropdownSubmenu() {
    // Classes
    const menuClass = 'dropdown-menu',
        submenuClass = 'dropdown-submenu',
        menuToggleClass = 'dropdown-toggle',
        disabledClass = 'disabled',
        showClass = 'show';

    if (submenuClass) {
        // Toggle submenus on all levels
        document.querySelectorAll(`.${menuClass} .${submenuClass}:not(.${disabledClass}) .${menuToggleClass}`).forEach(function (link) {
            link.addEventListener('click', function (e) {
                e.stopPropagation();
                e.preventDefault();

                // Toggle classes
                link.closest(`.${submenuClass}`).classList.toggle(showClass);
                link.closest(`.${submenuClass}`).querySelectorAll(`:scope > .${menuClass}`).forEach(function (children) {
                    children.classList.toggle(showClass);
                });

                // When submenu is shown, hide others in all siblings
                for (let sibling of link.parentNode.parentNode.children) {
                    if (sibling != link.parentNode) {
                        sibling.classList.remove(showClass);
                        sibling.querySelectorAll(`.${showClass}`).forEach(function (submenu) {
                            submenu.classList.remove(showClass);
                        });
                    }
                }
            });
        });

        // Hide all levels when parent dropdown is closed
        document.querySelectorAll(`.${menuClass}`).forEach(function (link) {
            if (!link.parentElement.classList.contains(submenuClass)) {
                link.parentElement.addEventListener('hidden.bs.dropdown', function (e) {
                    link.querySelectorAll(`.${menuClass}.${showClass}`).forEach(function (children) {
                        children.classList.remove(showClass);
                    });
                });
            }
        });
    }
}
